import React from 'react';
import { Button, Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const TitleHeaderBlock = (props) => {
  const { title, body, linkText, linkUrl, children } = props;

  return (
    <div className="TitleHeaderBlock">
      <Container>
        <div className="row TitleHeaderBlock__heading">
          <div className="col-12 col-sm-12 col-md-8 col-lg-9 TitleHeaderBlock__heading__content">
            {title ? (
              <h2>{title}</h2>
            ) : null}
            {body ? (
              <p>{body}</p>
            ) : null}
          </div>
          <div className="col-12 col-sm-12 col-md-4 col-lg-3 TitleHeaderBlock__heading__link">
            {linkUrl ? (
              <Button href={linkUrl} primary={false} className="Button--secondary">
                {linkText}
              </Button>
            ) : null}
          </div>
        </div>
      </Container>
      {/* Render the child data */}
      {children}
    </div>
  );
};

export default TitleHeaderBlock;
